(ns quuppa.qsm.site-plan.events
  (:require [cljs.tools.reader :as reader]
            [re-frame.core :as rf]
            [quuppa.peweb.query :as q]
            [quuppa.qsm.ui-state.events :as ui-state]
            [quuppa.qsm.planner.events :as planner-events]
            [ajax.core :as ajax]))

(def site-plans-query (q/create-query :qsm/list-site-plans [:site-id]))
(def active-site-plan-query (q/create-query :site/active-site-plan [:site-id]))

(rf/reg-event-fx :site-plan/new-active
  (fn [{:keys [db]} [_ event]]
    {:db (q/update-state-db db active-site-plan-query (fn [_old-result evt] (:site-plan evt)) event)
     :fx [[::q/execute [site-plans-query {:site-id (:site-id event)}]]]}))

(rf/reg-event-db :site-plan/upload
  (fn [db [_ event]]
    (-> db
        (q/update-state-db site-plans-query #(conj %1 (:site-plan %2)) event)
        (q/update-state-db active-site-plan-query (fn [_old-result evt] (:site-plan evt)) event))))

(rf/reg-event-fx ::site-plan-activated
  (fn [_ [_ qpe-identity resp]]
    {:fx [[:dispatch [::get-site-plan-password-and-set-engine-key qpe-identity (:id resp)]]
          [:dispatch [::close-site-plan-form]]
          [:dispatch [:notifications/notify-success {:message "Site plan changed"}]]]}))

(rf/reg-event-fx ::validation-failure
  (fn [_ [_ _site _site-plan-key error-resp]]
    (let [the-error (:ex-data error-resp)
          error     (if (= :duplicate-key (:type the-error))
                      (merge the-error
                             {:type  :error
                              :field "license-key"})
                      {:type    :error
                       :field   "license-key"
                       :error   "Could not upload the new Site Plan"
                       :err-msg "Invalid Site Plan Key or Password"})]
      {:fx [[:dispatch [::ui-state/assoc-in [:site :sidebar :site-plan-upload] :error]]
            [:dispatch [::ui-state/assoc-in [:site :sidebar :error] error]]]})))

(rf/reg-event-fx ::submit-site-plan-key
  (fn [_ [_ qpe-identity site {:keys [site-plan-key password]}]]
    {:fx [[:dispatch [::ui-state/assoc-in [:site :sidebar :site-plan-upload] :validating]]
          [:dispatch [::ui-state/update-in [:site :sidebar] dissoc :error]]
          [:server-dispatch {:event      [:site/upload-site-plan {:site-id (:id site)
                                                                  :site-plan-key site-plan-key
                                                                  :site-plan-password password}]
                             :timeout    30000
                             :on-success [::site-plan-activated qpe-identity]
                             :on-error   [::validation-failure site site-plan-key]}]]}))

(rf/reg-event-fx ::select-site-plan-key
  (fn [_ [_ qpe-identity site {:keys [site-plan-key]}]]
    {:fx [[:dispatch [::ui-state/assoc-in [:site :sidebar :site-plan-upload] :processing]]
          [:dispatch [::ui-state/update-in [:site :sidebar] dissoc :error]]
          [:server-dispatch {:event      [:site/activate-site-plan {:site-id (:id site)
                                                                    :site-plan-key site-plan-key}]
                             :on-success [::site-plan-activated qpe-identity]
                             :on-error   [::validation-failure site site-plan-key]}]]}))

(rf/reg-event-fx ::delete-previous
  (fn [_ [_ qpe-identity site-plan-name project-id]]
    {:fx [[:dispatch [:confirm/open {:title        "Delete site plan?"
                                     :message      [:span "You are about to delete '"
                                                    [:strong site-plan-name]
                                                    "'. Are you sure?"]
                                     :ok-label     "Delete"
                                     :ok-class     "btn btn-danger"
                                     :cancel-class "btn btn-outline-secondary"
                                     ;; FIXME: legacy 'remove project'. Removes the project folder from QPE. In the future
                                     ;; should remove site plan data from QSM [sc-27481] (if delete feature applicable)
                                     :on-confirm   [:qpe/remove-existing-project qpe-identity project-id]}]]]}))

(rf/reg-event-fx ::close-site-plan-form
  (fn [_ _]
    {:fx [[:dispatch [::ui-state/close-sidebar :site]]
          [:dispatch [::ui-state/update :site dissoc :site-plan-upload]]]}))

(rf/reg-event-fx ::set-engine-key
  (fn [_ [_ qpe-identity site-plan]]
    {:fx [[:qpe-dispatch {:qpe-identity qpe-identity
                          :event        [:qpe/req-select-submitted-project
                                         {:key             (:key site-plan)
                                          ; :path for submitted project key is the same as key, perhaps we should fill this in only on server?
                                          :path            (:key site-plan)
                                          :password        (:site-plan-password site-plan)
                                          :type            :online}]
                          :on-success   [:notifications/notify-success {:message "Successfully changed engine Site plan"}]
                          :on-error     [:qpe/project-change-failed qpe-identity]}]]}))

(rf/reg-event-fx ::activate-imdf-plan-on-engine
  (fn [_ [_ qpe-identity site-plan]]
    {:fx [[:qpe-dispatch {:qpe-identity qpe-identity
                          :event        [:qpe/req-select-qsm-siteplan
                                         {:key          (:key site-plan)
                                          :site-plan-id (str (:id site-plan))}]
                          :on-success   [:notifications/notify-success {:message "Engine is loading the IMDF plan"}]
                          :on-error     [:qpe/project-change-failed qpe-identity]}]]}))

(rf/reg-event-fx ::get-site-plan-password-and-set-engine-key
  (fn [_ [_ qpe-identity id]]
    {:fx [[:server-dispatch {:event        [:qsm/get-site-plan-by-id
                                            {:site-plan-id             id}]
                             :on-success   [::set-engine-key qpe-identity]
                             :on-error     [:notifications/notify]}]]}))

(rf/reg-event-fx ::create-site-plan
  (fn [{:keys [db]} [_ project-id site-id]]
    ; new site-plan date is an implicit parameter of -success, just the same as :xhrio
    {:fx [[:server-dispatch {:event [:qsm/create-site-plan (assoc (-> db :ui-state :site :sidebar :new-site-plan-form :data) :site-id site-id)]
                             :on-success [::create-site-plan-success project-id site-id]
                             :on-error [::create-site-plan-error "Create site failed"]}]]}))

(rf/reg-event-fx ::create-site-plan-success
  (fn [{:keys [db]} [_ project-id site-id created-site-plan]]
    (let [pending-floorplan (get-in db [:ui-state :site :sidebar :new-site-plan-form :pending-floorplan])]
      {:db (-> db
               (dissoc :site-plan-form)
               (update-in [:ui-state :site :sidebar :new-site-plan-form] dissoc :pending-floorplan))
       :fx (if pending-floorplan
             [[:dispatch [::upload-floorplan pending-floorplan (:id created-site-plan) project-id site-id]]]
             [[:dispatch [:nav/push-state :planner-site-plan
                          {:plan-id (:id created-site-plan)}]]])})))

(rf/reg-event-fx ::create-site-plan-error
  (fn [{:keys [db]} [_ message error]]
    ; NOTE Is this were we should store the error?
    {:db (assoc-in db [:ui-state :site :sidebar :new-site-plan-form :error] {:message message
                                                                             :data error})}))

(rf/reg-event-fx ::update-background-image-asset
  (fn [{:keys [db]} [_ plan-id background-image-id]]
    (let [raw-result (:result (q/get-result db planner-events/plan-query {:id plan-id}))
          ; FIXME we should remove the result from app-db and
          ; transform the data so it's usable in the planner
          ; and invoke loading floorplan images

          _ (println "::plan-loaded" raw-result)
          ;; Server currently returns EDN string; parse defensively.
          imdf-plan (cond
                      (string? raw-result) (reader/read-string raw-result)
                      (map? raw-result) raw-result
                      :else {})
          selected-building-id (-> db :quuppa.routing/match :parameters :query :building-id)
          selected-level-id (-> db :quuppa.routing/match :parameters :query :level-id)
          level (cond
                  (and selected-building-id selected-level-id)
                  (planner-events/extract-level imdf-plan selected-building-id selected-level-id)
                  selected-level-id
                  (planner-events/extract-level imdf-plan selected-level-id)
                  :else nil)
          background-image (get-in level [:siteresource-backgroundimages background-image-id])
          asset-id (:asset-id background-image)]
      {:fx [[:server-dispatch {:event      [:qsm/update-background-image-asset  asset-id]
                               :on-success [::update-background-image-asset-success]}]]})))

(rf/reg-event-fx ::upload-floorplan-success
  (fn [{:keys [db]} [_ site-plan-id project-id site-id response]]
    {:db (-> db
             (assoc-in [:ui-state :site :sidebar :new-site-plan-form :floorplan-upload :status] :success)
             (assoc-in [:ui-state :site :sidebar :new-site-plan-form :floorplan-upload :width] (:image-width response))
             (assoc-in [:ui-state :site :sidebar :new-site-plan-form :floorplan-upload :height] (:image-height response)))
     :fx [[:dispatch [:notifications/notify-success {:message "Floorplan image uploaded successfully"}]]
          ; response should contain building-id, level-id, background-id, see quuppa.qsm.site-plan.db/store-floorplan-image 
          [:dispatch [:nav/push-state :planner-site-plan
                      {:plan-id site-plan-id}
                      (-> response
                          (dissoc :status)
                          ; venue-id exists but there's only one per site-plan so not needed in URL
                          (dissoc :venue-id)
                          (assoc :action "set-scale"
                                 :project-id project-id
                                 :site-id site-id))]]]}))

(rf/reg-event-fx ::upload-floorplan-error
  (fn [{:keys [db]} [_ error]]
    {:db (-> db
             (assoc-in [:ui-state :site :sidebar :new-site-plan-form :floorplan-upload :status] :error)
             (assoc-in [:ui-state :site :sidebar :new-site-plan-form :floorplan-upload :error] error))
     :fx [[:dispatch [:notifications/notify-error {:message "Failed to upload floorplan image"}]]]}))

(rf/reg-event-fx ::upload-floorplan
  (fn [_ [_ js-file site-plan-id project-id site-id]]
    (let [form-data (js/FormData.)]
      (.append form-data "file" js-file)
      (.append form-data "site-plan-id" site-plan-id)
      {:fx [[:http-xhrio {:method          :post
                          :uri             "/site-plan/floorplan"
                          :body            form-data
                          :response-format (ajax/json-response-format {:keywords? true})
                          :on-success      [::upload-floorplan-success site-plan-id project-id site-id]
                          :on-failure      [::upload-floorplan-error]}]]})))

(rf/reg-event-fx ::delete-site-plan
  (fn [_ [_ {:keys [site-plan-id site-plan-name has-imdf-data site-id site-key qpe-identity]}]]
    (let [message (if has-imdf-data
                    [:<> "You are about to permanently delete "
                     [:strong site-plan-name]
                     " and all its IMDF data. Are you sure?"]
                    [:<> "You are about to permanently delete site plan " [:strong site-plan-name] " from QSM. The QSM will also attempt to remove the site plan from the engine. Are you sure?"])]
        {:fx [[:dispatch [:confirm/open {:title        "Delete Site Plan?"
                                         :message      message
                                         :ok-label     "Delete"
                                         :ok-class     "btn btn-danger"
                                         :cancel-class "btn btn-outline-secondary"
                                         :on-confirm   [::delete-site-plan-confirmed site-plan-id site-id site-key qpe-identity]}]]]})))

(rf/reg-event-fx ::delete-site-plan-confirmed
  (fn [_ [_ site-plan-id site-id site-key qpe-identity]]
    {:fx [[:server-dispatch {:event      [:qsm/delete-site-plan {:site-plan-id site-plan-id}]
                             :on-success [::delete-site-plan-success site-id]
                             :on-error   [:notifications/notify-error {:message "Failed to delete Site plan"}]}]
          [:qpe-dispatch {:qpe-identity qpe-identity
                          :event [:qpe/remove-project site-key]}]]}))

(rf/reg-event-fx ::delete-site-plan-success
  (fn [{:keys [db]} [_ site-id]]
    {:db (q/update-state-db db active-site-plan-query (fn [_ _] nil) {:site-id site-id})
     :fx [[:dispatch [:confirm/close]]
          [:dispatch [:notifications/notify-success {:message "Site plan deleted"}]]]}))

(rf/reg-event-db ::open-authorization-modal
  (fn [db [_ site-plan]]
    (assoc-in db [:ui-state :site :site-plan-authorization]
              {:site-plan site-plan
               :expires-in :one-week
               :status :idle})))

(rf/reg-event-db ::close-authorization-modal
  (fn [db _]
    (update-in db [:ui-state :site] dissoc :site-plan-authorization)))

(rf/reg-event-db ::set-authorization-expiration
  (fn [db [_ expires-in]]
    (assoc-in db [:ui-state :site :site-plan-authorization :expires-in] expires-in)))

(rf/reg-event-fx ::generate-authorization-token
  (fn [{:keys [db]} _]
    (let [{:keys [site-plan expires-in]} (get-in db [:ui-state :site :site-plan-authorization])]
      {:db (assoc-in db [:ui-state :site :site-plan-authorization :status] :generating)
       :fx [[:server-dispatch {:event [:qsm/generate-site-plan-authorization-token
                                       {:site-plan-id (:id site-plan)
                                        :expires-in expires-in}]
                              :on-success [::authorization-token-generated]
                              :on-error [::authorization-token-error]}]]})))

(rf/reg-event-db ::authorization-token-generated
  (fn [db [_ token-data]]
    (-> db
        (assoc-in [:ui-state :site :site-plan-authorization :status] :generated)
        (assoc-in [:ui-state :site :site-plan-authorization :token-data] token-data)
        (update-in [:ui-state :site :site-plan-authorization] dissoc :error))))

(rf/reg-event-db ::authorization-token-error
  (fn [db [_ error]]
    (-> db
        (assoc-in [:ui-state :site :site-plan-authorization :status] :error)
        (assoc-in [:ui-state :site :site-plan-authorization :error] error))))

(rf/reg-event-fx ::download-site-plan
  (fn [_ [_ site-plan-id site-plan-key]]
    (let [download-url (str "/site-plan/download/" site-plan-id)
          filename (str "site-plan-" site-plan-key ".zip")]
      ;; Create a temporary link element to trigger the download
      (let [link (.createElement js/document "a")]
        (set! (.-href link) download-url)
        (set! (.-download link) filename)
        (.appendChild (.-body js/document) link)
        (.click link)
        (.removeChild (.-body js/document) link))
      {:fx [[:dispatch [:notifications/notify-success {:message "Site plan download started"}]]]})))
